/**
 * Indicates the status of the party identified with PartyDetailID(1691).
 * tag: 1672
 * @readonly
 * @enum {number} (int)
 */
export enum PartyDetailStatus {
  /** Active (default if not specified) */
  Active = 0,
  /** Suspended */
  Suspended = 1,
  /** Halted */
  Halted = 2,
}
